<template>
  <div class="user-search-input">
    <b-form
      @submit="
        $event.preventDefault();
        $emit(userSearchEvent, searchString);
      "
    >
      <b-form-group>
        <b-form-radio-group
          :options="displayRoles"
          v-model="selectedRole"
          @change="$emit(newSearchRoleEvent, $event)"
        >
        </b-form-radio-group>
      </b-form-group>
      <b-form-group>
        <b-input-group style="max-width:500px">
          <b-form-input
            ref="searchInput"
            type="search"
            v-model="searchString"
            placeholder="enter user name or email"
            @input="$emit(newSearchInputEvent, $event)"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="outline-secondary"
              @click="$emit(userSearchEvent, searchString)"
              >User Search</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import {
  BFormRadioGroup,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BForm
} from "bootstrap-vue";

export const NewSearchRoleEvent = "new-search-role";
export const NewSearchInputEvent = "new-search-input";
export const UserSearchEvent = "run-search";
export default {
  name: "UserSearchInput",
  components: {
    BFormRadioGroup,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BForm
  },
  props: {
    allRoles: Array,
    initialSelectedRole: {
      type: String,
      default: "Student"
    },
    initialSearchState: String
  },
  mounted() {
    if (this.searchString.length > 0) {
      this.$refs.searchInput.focus();
    }
  },
  data: function() {
    return {
      searchString: this.initialSearchState,
      selectedRole: this.initialSelectedRole,
      displayRoles: ["All", ...this.allRoles],
      newSearchRoleEvent: NewSearchRoleEvent,
      newSearchInputEvent: NewSearchInputEvent,
      userSearchEvent: UserSearchEvent
    };
  },
  methods: {
    alert: text => alert(text)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
